import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createProduct } from "../../Redux/Actions/sellerAction";

const CreateProductSeller = () => {
  const dispatch = useDispatch();

  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [stocks, setStocks] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [productCategory, setProductCategory] = useState("");

  function handleCreateProduct() {
    const productData = {
      productName: productName,
      price: price,
      stocks: stocks,
      productDescription: productDescription,
      productCategory: productCategory,
    };

    dispatch(createProduct(productData));
  }

  return (
    <div>
      <div className="form w-full  md:px-12 px-2 mb-3">
        <div className="w-auto  md:mx-auto  border-gray-300 px-3 py-3">
          <h1 className="text-lg text-gray-800 font-semibold mb-3 pb-4 border border-transparent border-b-gray-200">
            Bussiness Infromation for ashok@291
          </h1>

          {/* <div className="mb-3">
            <label
              for="registration"
              className="block mb-1 text-sm font-semibold text-gray-900 "
            >
              Company registration number
            </label>
            <input
              type="text"
              id="registration"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
              placeholder="sfsdaf2121"
              required=""
            />
          </div> */}
          <div className="mb-3">
            <label
              for="productname"
              className="block mb-1 text-sm font-semibold text-gray-900"
            >
              Product Name
            </label>
            <input
              type="text"
              id="productname"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
              placeholder="Sweater"
              required=""
            />
          </div>
          <div className="mb-3">
            <label
              for="price"
              className="block mb-1 text-sm font-semibold text-gray-900 "
            >
              Price
            </label>
            <input
              type="text"
              id="price"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
              placeholder="$1200.50"
              required=""
            />
          </div>
          <div className="mb-3">
            <label
              for="description"
              className="block mb-1 text-sm font-semibold text-gray-900 "
            >
              Product Description
            </label>
            <input
              type="text"
              id="description"
              value={productDescription}
              onChange={(e) => setProductDescription(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
              placeholder="description"
              required=""
            />
          </div>
          <div className="shop prodct category mb-2">
            <label
              for="category"
              className="block text-sm font-semibold text-gray-800 mb-2 "
            >
              Choose category
            </label>
            <select
              id="category"
              value={productCategory}
              onChange={(e) => setProductCategory(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm md:w-64 w-full outline-none block p-2 "
            >
              <option selected>Choose category</option>
              <option value="US">groccery</option>
              <option value="CA">Jewellery</option>
              <option value="FR">Sports products</option>
              <option value="DE">Germany</option>
            </select>
          </div>
          <div className="mb-3">
            <label
              for="stock"
              className="block mb-1 text-sm font-semibold text-gray-900 "
            >
              Stocks
            </label>
            <input
              type="text"
              id="stock"
              value={stocks}
              onChange={(e) => setStocks(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
              placeholder="description"
              required=""
            />
          </div>
          <button
            onClick={handleCreateProduct}
            className="text-white bg-amber-500 hover:bg-amber-500/90 border shadow-sm   focus:outline-none font-medium rounded-sm text-sm w-full  px-5 py-2 mt-2 text-center "
          >
            CreateProduct
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateProductSeller;
